import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { NCRContext } from 'views';
import { UserContext } from 'components/routing';

import { SubmitButton } from 'components/form/prototypes';

const Save = ({ isReturn }) => {
  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);
  const { id } = useParams();

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Visible if status is not "Closed" or "Cancelled"
    setVisible((_) => ![6, 7].includes(state.ncr.status.id));
  }, [state.ncr.status.id]);

  let request = {
    method: null,
    url: null,
    data: {
      ...state.ncr,
    },
  };

  // PATCH if NCR ID exists, POST if new NCR
  if (id) {
    request.method = 'patch';
    request.url = `/api/ncr/${id}`;
    request.data.amended_by = user.id;
  } else {
    request.method = 'post';
    request.url = `/api/ncr/`;
    request.data.created_by = user.id;
    request.data.amended_by = user.id;
  }

  return (
    visible && (
      <SubmitButton
        name="Save"
        request={request}
        toast={{ message: 'Saved' }}
      />
    )
  );
};

export { Save };
